<template>
  <div>
    <div class="search flex-box bb">
      <label for="searchClub" class="flex2 flex-box flex-v-c" :class="{br:searchClubId}">
        <input
          id="searchClub"
          class="searchClub"
          type="number"
          @input="inputNull"
          placeholder="输入亲友圈ID查询"
          v-model="searchClubId"
        >
        <div class="closeBtn" v-show="searchClubId" @click="clear"></div>
      </label>
      <div class="flex1 flex-box flex-hv-c" @click="search" v-show="searchClubId">
        <div class="button">
          搜索
          <i class="iconfont icon-search"></i>
        </div>
      </div>
    </div>

    <div class="info">
      <ul>
        <div class="flex-box flex-hv-c">
          <img class="avatar" :src="data.headimgurl" alt>
        </div>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">游戏ID：{{data.gameId}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">昵称：{{data.nickname}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">亲友圈创建时间：{{data.clubCreateTime | formatDate}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">
            所属商务：{{data.realname}}
            <span class="tip">{{data.manager}}</span>
          </span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">亲友圈人数：{{data.clubUserCount}}</span>
        </li>
        <li class="flex-box flex-v-c bb">
          <span v-if="data">亲友圈昨日场次：{{data.clubPlayYesterday}}</span>
        </li>

        <div class="button setToggleBtn" v-if="data" @click="check">{{buttonTxt}}</div>
      </ul>
    </div>
  </div>
</template>
<!--javascript-->
<script>
export default {
  data: function () {
    return {
      data: '',
      searchClubId: '',
      buttonTxt: '申请解散',
      clubId: ''
    }
  },
  methods: {
    check() {
      var that = this;
      if (this.data.clubUserCount >= 10) {
        this.$toast('大于10人亲友圈，请联系客服申请解散')
        this.buttonTxt = '大于10人亲友圈，请联系客服申请解散'
      } else {

        if (localStorage.getItem('managerId') == this.data.managerId) {
          this.$messagebox.confirm('是否确认解散？', '提示').then(() => {
            that.req()
          })

        } else {
          this.$toast('该亲友圈不是您商务名下，不能操作解散')
          this.buttonTxt = '该亲友圈不是您商务名下，不能操作解散'
        }
      }
    },
    req() {

      this.$http.post('/club/disband', { clubId: this.searchClubId }).then((res) => {
        if (res.code == 0) {
          this.buttonTxt = '解散成功'
          this.$toast('解散成功')
        } else {
          this.$toast(res.message)
        }
      })


    },
    search() {
      this.$http.get('/club/info', { params: { clubId: this.searchClubId } }).then((res) => {
        if (res.code == 0) {
          this.data = res.data
          /*if (!this.data.userMember) {
            this.buttonTxt = '该玩家还没绑定代理，无需解绑'
            this.flag = false
          }*/
        } else {
          this.$toast(res.message)
        }
      })
    },
    inputNull() {
      this.data = '';
      this.buttonTxt = '申请解散';
    },
    clear() {
      this.searchClubId = '';
      this.data = '';
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.search {
  height: 1rem;
}

.searchClub {
  width: 100%;
  padding-left: 10px;
  text-align: center;
}

.info ul {
  padding: 0 0.5rem;
  margin-top: 0.5rem;
  li {
    height: 0.7rem;
  }
}

.avatar {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  -webkit-box-shadow: 5px 4px 6px #ddd;
  box-shadow: 5px 4px 6px #ddd;
}

.setToggleBtn {
  margin-top: 0.5rem;
  height: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/delClub/index.vue